import Spinner from '@Components/Feedback/Spinner';
import { useFrameContext } from '@Containers/Layout/FrameContainer';
import Gql from '@Core/Gql';
import gql from 'graphql-tag';
import React, { useEffect } from 'react';

const GET_GITLAB_PIPELINE_QUERY = gql`
    query GetGitlabPipeline($id: Int!) {
        gitLabPipeline(id: $id) {
            id
            status
        }
    }
`

export default function CmsLoader() {
    const { cmsLoading, setCmsLoading } = useFrameContext();

    useEffect(() => {
        const poll = async (firstRun = false) => {
            if (!cmsLoading) {
                return;
            }

            if (!firstRun) {
                const { gitLabPipeline } = await Gql().request(
                    GET_GITLAB_PIPELINE_QUERY,
                    { id: cmsLoading }
                );

                if (gitLabPipeline.status === 'success') {
                    setCmsLoading(0);
                    return;
                }
            }

            setTimeout(poll, 3000);
        };

        if (cmsLoading) {
            void poll(true);
        }
    }, [cmsLoading]);

    if (!cmsLoading) {
        return null;
    }

    return <Spinner />;
}
